<template>
    <div>
        <default-chart :labels="label" :items="data" :height="120"></default-chart>
    </div>
</template>

<script>
    import DefaultChart from "../DefaultChart";

    export default
    {
        components: {DefaultChart},
        props: {
            productId: {
                type: Number,
                required: true,
            },
            days: {
                type: Number,
                required: true
            },
        },
        data() {
            return {
                label: [],
                data: [],
            }
        },
        mounted()
        {
            this.init();
        },
        methods:
        {
            init() {
                let data = {
                    days: this.days,
                    product_id: this.productId,
                };

                this.$http.get('price-history/chart', {params: data}).then(response => {
                    this.label = response.body.label;
                    this.data = response.body.data;
                })
            },
        },
        watch: {
            productId: {
                handler: function () {
                    this.init();
                }
            },
            days: {
                handler: function () {
                    this.init();
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// Chart.vue?5856dfe5